/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coverapppreviewfeed3Inputs */

const en_coverapppreviewfeed3 = /** @type {(inputs: Coverapppreviewfeed3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Home`)
};

const de_coverapppreviewfeed3 = /** @type {(inputs: Coverapppreviewfeed3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Startseite`)
};

/**
* | output |
* | --- |
* | "Home" |
*
* @param {Coverapppreviewfeed3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const coverapppreviewfeed3 = /** @type {((inputs?: Coverapppreviewfeed3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coverapppreviewfeed3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_coverapppreviewfeed3(inputs)
	return de_coverapppreviewfeed3(inputs)
});
export { coverapppreviewfeed3 as "coverAppPreviewFeed" }